"use strict";

var SignalActions = require("app/shared/actions/signal-actions");
var TeamSelector = require("app/shared/components/TeamSelector/team-selector");
var AddTeamPrompt = require("app/shared/components/TeamSelector/add-team-prompt");
var agendorAPI = require("app/util/api/agendor-api");
var usersAPI = require("app/util/api/users");
var teamsAPI = require("app/util/api/team");
var text = require("app/util/formatter/text");
var util = require("app/util/util");
var _ = require("underscore");
var Intl = require("intl");
var ReactIntl = require("react-intl");

var TeamSelectorContainer = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    userId: React.PropTypes.string,
    onSelect: React.PropTypes.func,
    onLoad: React.PropTypes.func,
    className: React.PropTypes.string
  },
  getInitialState: function() {
    return {
      teams: null,
      teamName: "",
      optionValue: 0,
      leaderSelection: [],
      memberSelection: [],
      shouldRenderPrompt: false,
    };
  },
  componentDidMount: function() {
    this.getTeams();
    this.getUsers();
    if (this.props.userId) {
      this.getUserTeam(this.props.userId);
    }
  },
  getTeams: function() {
    teamsAPI.get(this.handleGetTeamsSuccess, this.handleRequestError);
  },
  getUsers: function() {
    var params = {active: true};
    usersAPI.get(params,this.handleGetUserSuccess, this.handleRequestError);
  },
  getUserTeam: function(userId) {
    var params = { id: userId, display: "user_teams" };
    usersAPI.getById(params, this.handleGetUserTeamSuccess, this.handleRequestError);
  },
  postTeam: function(team) {
    teamsAPI.post(team, this.handlePostTeamSuccess, this.handleRequestError);
  },
  handleGetUserSuccess: function(body, response) {
    if(body.length != 0) {
      this.setState({ leaderSelection: body, memberSelection: util.deepClone(body) });
    }
  },
  handleGetUserTeamSuccess: function(body, response) {
    if(body.user_teams && body.user_teams.length != 0) {
      var selectedTeam = _.findWhere(body.user_teams, {"leader": 0});
      if (selectedTeam) {
        this.props.onLoad(selectedTeam);
        this.setState({ optionValue: selectedTeam.team_id });
      }
    }
  },
  handleGetTeamsSuccess: function(body, response) {
    var teamsOptions = [];
    teamsOptions = this.prepareTeamsOptions(body);
    this.setState({ teams: teamsOptions });
  },
  prepareTeamsOptions: function(teams) {
    var teamsOptions = [];
    _.each(teams, function(team) {
      var addTeam = {
        id: team.id,
        name: team.name
      };
      teamsOptions.push(addTeam);
    });
    return teamsOptions;
  },
  handlePostTeamSuccess: function(body, response) {
    var newTeam = { id: body.id, name: body.name };
    this.teamCreated(newTeam);
    this.teamSelected(newTeam.id);
    this.setState({ shouldRenderPrompt: false });
  },
  teamCreated: function(newTeam) {
    var teamsOptions = _.clone(this.state.teams);
    teamsOptions.splice(1, 0, newTeam);
    this.setState({ teams: teamsOptions });
  },
  teamSelected: function(teamId) {
    var selectedTeam = {};

    if (teamId && text.isInt(teamId)) {
      selectedTeam = _.findWhere(this.state.teams, {id: parseInt(teamId)});
      this.setState({ optionValue: teamId });
    } else {
      selectedTeam = { id: null };
      this.setState({ optionValue: 0 });
    }

    if (this.props.onSelect) {
      this.props.onSelect(selectedTeam);
    }
  },
  handleRequestError: function(body, response) {
    var errorMessage = this.handleErrorMessage(body, response);
    this.showSignal(errorMessage);
  },
  handleErrorMessage: function(body, response) {
    var errorMessage = "";
    var isBodyAnObject = body[0] !== null && typeof body[0] === "object";

    if (body.message) {
      errorMessage = body.message + ". Por favor, tente novamente mais tarde.";
    } else if (isBodyAnObject && "error" in body[0]) {
        if (body[0].error.match(/has already been taken/g)) {
          errorMessage = "Está equipe já foi cadastrada.";
        }
    } else if (response || response.status === 403) {
      errorMessage = "Função disponível somente para administradores da conta.";
    } else {
      errorMessage = "Ocorreu um erro. Por favor, tente novamente mais tarde.";
    }
    return errorMessage;
  },
  showSignal: function(message) {
    SignalActions.show({
      message: message,
      type: "warning",
      hideTimeout: 10000
    });
  },
  handleOnChangeOptions: function(obj){
    if (obj.value === "+ Criar Equipe") {
      this.showAddTeamPrompt();
    } else {
      this.teamSelected(obj.value);
    }
  },
  showAddTeamPrompt: function() {
    this.setState({optionValue: 0, shouldRenderPrompt: true});
  },
  handleOnChangeName: function(e) {
    this.setState({ teamName: e.target.value});
  },
  handleLeaderSelection: function(users) {
    this.setState({
      leaderSelection: users
    });
  },
  handleMemberSelection: function(users) {
    this.setState({
      memberSelection: users
    });
  },
  onClosePrompt: function() {
    this.setState({teamName: ""});
    this.setState({shouldRenderPrompt: false});
  },
  onConfirmPrompt: function(){
    var checkedLeaders = this.filterByChecked(this.state.leaderSelection);
    var checkedMembers = this.filterByChecked(this.state.memberSelection);
    var userTeams = this.convertIntoUserTeams(checkedLeaders, checkedMembers);

    var postParams = {
      name: this.state.teamName,
      user_teams: userTeams
    };
    this.postTeam(postParams);
  },
  filterByChecked: function(users) {
    return _.where(users, {checked: true});
  },
  convertIntoUserTeams: function(leaders, members) {
    var userTeamLeaders = this.convertIntoUserTeam(leaders, true);
    var userTeamMembers = this.convertIntoUserTeam(members, false);

    return _.union(userTeamLeaders, userTeamMembers);
  },
  convertIntoUserTeam: function(users, isLeader) {
    return users.map(function(user) {
      return {
        user: {id: user.id},
        leader: isLeader
      };
    });
  },
  render: function(){
    var props = {
      value: this.state.optionValue,
      options: this.state.teams,
      handleOnChangeOptions: this.handleOnChangeOptions,
      shouldRenderPrompt: this.state.shouldRenderPrompt,
      handleOnChangeName: this.handleOnChangeName,
      handleLeaderSelection: this.handleLeaderSelection,
      handleMemberSelection: this.handleMemberSelection,
      teamName: this.state.teamName,
      leaderSelection: this.state.leaderSelection,
      memberSelection: this.state.memberSelection,
      onClosePrompt: this.onClosePrompt,
      onConfirmPrompt: this.onConfirmPrompt,
      renderPrompt: this.props.renderPrompt,
      className: this.props.className
    };

    return <TeamSelector {...props}/>;
  }
});

module.exports = TeamSelectorContainer;



// WEBPACK FOOTER //
// ./app/shared/components/TeamSelector/team-selector-container.jsx